import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';

if(document.getElementById('MyInterests'))
{
	// Need to differentiate between refresh and initial pull
	const myInterestsUrl = '/UserInterestsTree/?parentId=20&lang=' + currentLang();
	const myLocationUrl = '/UserInterestsTree/?parentId=164,165,198,199,200&lang=' + currentLang();
	const myInterestsRefreshUrl = '/UserInterestsTree/RefreshTree?parentId=20';
	const myLocationRefreshUrl = '/UserInterestsTree/RefreshTree?parentId=164,165,198,199,200';

	// define the item component
	Vue.component('interest-item', {
		template: '#item-template',
		props: {
			model: Object
		},
		computed: {
			isFolder: function () {
				const self = this;
				return self.model.children &&
					self.model.children.length;
			},
		},
		methods: {
			toggleOpen: function () {
				const self = this;
				if (self.isFolder) {
					self.model.open = !self.model.open;
				}
			},
			toggleChecked: function () {
				const self = this;

				self.model.checked = !self.model.checked;

				if (self.isFolder) {
					recurseTree(self.model, self.model.checked);
				}
			},
		}
	});

	// define the item component
	Vue.component('location-interest-item', {
		template: '#location-item-template',
		props: {
			model: Object
		},
		methods: {
			toggleChecked: function () {
				const self = this;

				self.model.checked = !self.model.checked;
			},
		}
	});

	// recursive functions must be outside of vue; it doesn't recognize the function from inside it's function
	function recurseTree(node, active) {
		for (var x = 0; x < node.children.length; x++) 
		{
			node.children[x].checked = active;
			node.open = true;

			if(node.children[x].children != null && node.children[x].children.length > 0)
				recurseTree(node.children[x], active);
		}
	}

	const isSubmit = document.getElementById('IsSubmit');
	const isInitial = document.getElementById('IsInitial');
	const currentLanguage = document.getElementById('CurrentLanguage');

	// construct my interests url
	if(isSubmit.value)
	{
		const userInterests = document.getElementById('SubmitInterests');
		const userLocations = document.getElementById('SubmitLocation');
		const userReceiveEmails = document.getElementById('SubmitLanguagePreference');

		var myInterestsFinal = myInterestsRefreshUrl;
		if(userInterests)
			myInterestsFinal += '&submittedIds=' + userInterests.value;
		if(userReceiveEmails)
			myInterestsFinal += '&languagePreference=' + userReceiveEmails.value;

		myInterestsFinal += '&lang=' + currentLanguage.value;

		// construct locations url
		var myLocationFinal = myLocationRefreshUrl;
		if(userLocations)
			myLocationFinal += '&submittedIds=' + userLocations.value;

		myLocationFinal += '&lang=' + currentLanguage.value;
	}
	else
	{
		myInterestsFinal = myInterestsUrl;
		myLocationFinal = myLocationUrl;
	}

	request().get(myInterestsFinal).then(function(response) {
		const MyInterests = new Vue({
			el: '#MyInterests',
			data: {
				modelInterests: '',
				modelLocations: '',
				isLoading: true,
				selectedCategory: '',
			},
			mounted: function() {
				const self = this;
				self.selectedCategory = 'interests';

				const locationSwitchTab = document.getElementById('LocationSwitchTab');
				if(locationSwitchTab.value)
				{
					document.getElementsByClassName('interests__navigation')[0].children[1].setAttribute('selected', true);
					self.loadInterests(1);
				}
				else
				{
					document.getElementsByClassName('interests__navigation')[0].children[0].setAttribute('selected', true);
					self.isLoading = false; // early load, no need to wait for second call
				}

				self.modelInterests = response.userInterests;

				// set checkbox to please choose only if on registration wizard and they don't previously have values there to contact them
				var languagePreference = document.getElementById('SubmitLanguagePreference');
				if(isInitial.value && !isSubmit.value && response.submitLanguagePreference == 'DontSend')
					languagePreference.value = '';
				else
					languagePreference.value = response.submitLanguagePreference;

				request().get(myLocationFinal).then(function(response) {
					self.modelLocations = response.userInterests;
					self.isLoading = false;
				});
			},
			// Methods
			methods: {
				// Load Primary Menu
				// Only happends when 
				// Component is Mounted
				loadInterests: function (index, event) {
					const self = this;
					var interestsLinks = document.getElementsByClassName('interests__navigation')[0];

					// removes selected link style
					for (var i = 0; i < interestsLinks.children.length; i++) {
						interestsLinks.children[i].removeAttribute('selected');
					}

					// if (event) means if clicked!
					if (event) {
						// Add selected to clicked el
						event.currentTarget.setAttribute('selected', true);
					}
					// if forced
					else {
						// This is weird, but even if the component is mounted,
						// wait for Next Tick, this has tripped me more than once :/
						Vue.nextTick(function () {
							interestsLinks.children[index].setAttribute('selected', true);
						});
					}

					if (index == 0) {
						self.selectedCategory = 'interests';
					}
					else {
						self.selectedCategory = 'locations';
					}
				},
			}
		});
	});
}



// WEBPACK FOOTER //
// ../components/myinterests/myinterests.js